import { defineStore } from 'pinia'
import SerialSettingsState, { SerialSettingsStateType } from './state'
import { SerialSettingsActions, SerialSettingsActionsType } from './actions'
import { SerialSettingsGetters } from './getters'

export const useSerialSettingsStore = defineStore<
  'serialSettings',
  SerialSettingsStateType,
  typeof SerialSettingsGetters,
  SerialSettingsActionsType
>('serialSettings', {
  state: SerialSettingsState,
  actions: SerialSettingsActions,
  getters: SerialSettingsGetters,
})
